module.exports = __webpack_public_path__ + "static/media/Add Droplist_1576243035263.88f77b02.mp4";